module.exports = __webpack_public_path__ + "img/cumple.a1364359.jpg";